import {
    SET_ROLES,
    SET_EDIT_ROLE,
    SET_NEW_ROLE,
    SET_DELETE_ROLE,
    SET_DELETE_MULTI_ROLE,
    SET_LIST_ROLES,
    SET_ONE_ROLE,
    RESET_ITEMS_ROLE,
    RESET_SELECTED_ROLE,
    RESET_LIST_ROLES,
} from "redux/constants/Roles";

const initalAgreementState = {
    items: [],
    list: [],
    selected: {},
    loading: true,
};
const Roles = (state = initalAgreementState, action) => {
    const { type, payload } = action;

    switch (type) {
        case SET_ROLES: {
            return { ...state, items: payload, loading: false };
        }
        case SET_LIST_ROLES: {
            return { ...state, list: payload };
        }
        case SET_ONE_ROLE: {
            return { ...state, selected: payload, loading: false };
        }
        case SET_NEW_ROLE: {
            return { ...state, items: [payload, ...state.items] };
        }

        case SET_EDIT_ROLE: {
            let list = [...state.items];

            try {
                let ind = list.findIndex((item) => item._id === payload._id);

                if (ind > -1) {
                    list[ind] = payload;
                }
            } catch (error) {}

            return { ...state, items: list };
        }

        case SET_DELETE_ROLE: {
            let list = state.items.filter((item) => item._id !== payload);
            return { ...state, items: list };
        }

        case SET_DELETE_MULTI_ROLE: {
            let arr = payload.split(",");
            let list = state.items.filter((item) => !arr.includes(item._id));

            return { ...state, items: list };
        }
        case RESET_ITEMS_ROLE: {
            return { ...state, items: [], loading: true };
        }
        case RESET_LIST_ROLES: {
            return { ...state, list: [] };
        }
        case RESET_SELECTED_ROLE: {
            return { ...state, selected: {}, loading: true };
        }

        default:
            return state;
    }
};

export default Roles;
